import { render } from "./AdminMigrateVerify.vue?vue&type=template&id=c919d82c&scoped=true"
import script from "./AdminMigrateVerify.vue?vue&type=script&lang=js"
export * from "./AdminMigrateVerify.vue?vue&type=script&lang=js"

import "./AdminMigrateVerify.vue?vue&type=style&index=0&id=c919d82c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c919d82c"]])

export default __exports__